<template>
  <div :class="{ 'toggle-disabled': disabled }">
    <div class="d-flex toggle-container">
      <div class="flex-grow-1">
        <v-chip
          class="w-100 left-option justify-center"
          small
          :class="[
            scope === $constants.SEARCH_SCOPES.site
              ? 'active-button'
              : 'regular-button',
            { 'cursor-default': disabled },
          ]"
          @click="$emit('change', $constants.SEARCH_SCOPES.site)"
          >{{ $t('common.my_site') }}
        </v-chip>
      </div>

      <div class="flex-grow-1">
        <v-chip
          class="w-100  right-option  justify-center"
          small
          :class="[
            scope === $constants.SEARCH_SCOPES.global
              ? 'active-button'
              : 'regular-button',
            { 'cursor-default': disabled },
          ]"
          @click="$emit('change', $constants.SEARCH_SCOPES.global)"
          >{{ $t('common.all') }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'

export default {
  name: 'SearchScopeSelector',

  props: {
    disabled: Boolean,
    scope: {
      type: String,
      validator: value =>
        Object.values(constants.SEARCH_SCOPES).includes(value),
    },
  },
}
</script>

<style scoped lang="scss">
.toggle-disabled {
  opacity: 0.7;
  pointer-events: none;
}
.toggle-container {
  background-color: $color-blue-grey-lighten3;
  border-radius: 12px;
  padding-bottom: 2px;
}
.left-option {
  right: -2px;
}
.right-option {
  left: -2px;
}
.active-button {
  background-color: $color-blue !important;
  color: $color-white !important;
  z-index: 1;
}
.regular-button {
  background-color: $color-blue-grey-lighten3 !important;
  color: $color-blue-grey-darken1 !important;
}
</style>
